var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C9.20938 8 11 6.20906 11 4C11 1.79094 9.20938 0 7 0C4.79063 0 3 1.79094 3 4C3 6.20906 4.79063 8 7 8ZM8.58438 9.5H5.41563C2.42406 9.5 0 11.925 0 14.9156C0 15.5156 0.485 16 1.08312 16H12.9156C13.5156 16 14 15.5156 14 14.9156C14 11.925 11.575 9.5 8.58438 9.5ZM14.9719 10H12.6641C14.1 11.1781 15 12.9406 15 14.9156C15 15.3156 14.8813 15.6844 14.6875 16H19C19.5531 16 20 15.55 20 14.9719C20 12.2375 17.7625 10 14.9719 10ZM13.5 8C15.4344 8 17 6.43437 17 4.5C17 2.56562 15.4344 1 13.5 1C12.7153 1 11.9987 1.26734 11.415 1.70344C11.775 2.39469 12 3.16875 12 4C12 5.11 11.6272 6.12938 11.0128 6.95969C11.6469 7.6 12.525 8 13.5 8Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.aefb9718355770cdcb73f5552bae1772.svg";
export { ForwardRef as ReactComponent };